

import { Button } from '@/components/ui/button';
import { BookOpen } from 'lucide-react';

interface EmptyStateProps {
  searchQuery: string;
  onAddSession?: () => void;
}

export function EmptyState({ searchQuery, onAddSession }: EmptyStateProps) {
  // Different message if we're filtering vs showing an empty state
  const isFiltering = searchQuery && searchQuery.trim() !== '';
  
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center space-y-4">
      <div className="bg-primary-50 p-4 rounded-full">
        <BookOpen className="h-10 w-10 text-primary" />
      </div>
      
      <h3 className="text-xl font-medium">
        {isFiltering 
          ? `No sessions match "${searchQuery}"`
          : "No training sessions yet"}
      </h3>
      
      <p className="text-muted-foreground max-w-sm">
        {isFiltering
          ? "Try adjusting your search or filters to find what you're looking for."
          : "Start logging your training sessions to track your progress over time."}
      </p>
      
      {!isFiltering && onAddSession && (
        <Button onClick={onAddSession}>
          Log Training Session
        </Button>
      )}
    </div>
  );
}
